import btn1 from './btn1.vue';
btn1.install = Vue => Vue.component(btn1.name,btn1);
export default btn1;



// WEBPACK FOOTER //
// ./src/packages/button/btn1/index.js